import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { onResponseCreateTypeOfMeeting } from "./helpers";

const createTypeOfMeeting = async (data: CreateTypeOfMeetingReqT) =>
  axios.post(Routes.CREATE_TYPE_OF_MEETING, data);

export const useCreateTypeOfMeeting = () =>
  useMutation({
    mutationKey: [Keys.CREATE_TYPE_OF_MEETING],
    mutationFn: createTypeOfMeeting,
    onSettled: onResponseCreateTypeOfMeeting,
    cacheTime: Infinity,
  });
